import { render } from "./luckUser.vue?vue&type=template&id=0c6cf4d3"
import script from "./luckUser.vue?vue&type=script&lang=js"
export * from "./luckUser.vue?vue&type=script&lang=js"

import "./luckUser.vue?vue&type=style&index=0&id=0c6cf4d3&lang=css"

import exportComponent from "E:\\waibao\\isa-community-toupin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__